import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import TableText from "../TableText";
import { columnsData } from './data'
import { toJS, runInAction, action } from 'mobx';

const { TextArea } = Input;

@inject('store')
@observer
class App extends Component {
    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.monthlyAnalysis.data);
        data[i][name] = value;
        this.props.store.monthlyAnalysis.data = data;
    }
    render() {
        const { data, notes, loading } = this.props.store.monthlyAnalysis;
        const width = document.body.offsetWidth > 2100 ? document.body.offsetWidth - 1800 : 300;
        const columns = columnsData.map(item => {
            if (item.key == 'name') {
                return {
                    title: item.title,
                    dataIndex: item.key,
                    key: item.key,
                    fixed: 'left',
                    width,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index,
                            type: item.type,
                            name: item.key,
                            onChange: this.onChange,
                            totalIndex: [],
                        };
                        return <TableText data={{ ...props }} />
                    }
                }
            }
            return {
                title: item.title,
                dataIndex: item.key,
                key: item.key,
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index: index + 6,
                        type: item.type,
                        name: item.key,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: {
                            title: [item.title],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }
        })
        return (
            <div className="">
                <Row className="secondary_title">三．盈利能力分析</Row>
                <div className="text_c"><span className="span_41">（1）</span>客房利润率=（客房收入-客房成本-客房费用）/客房收入</div>
                <div className="text_c text_indent m_b_10">客房部门利润率(小于百分之七十五需要做出解释）</div>
                <div className="text_c"><span className="span_41">（2）</span>餐饮利润率=（餐饮收入-餐饮成本-餐饮费用）/餐饮收入</div>
                <div className="text_c text_indent m_b_10">餐饮部门利润率（小于百分之三十需要做出解释）</div>
                <div className="text_c"><span className="span_41">（3）</span>经营毛利率=经营毛利润/总收入</div>
                <div className="text_c text_indent">根据预算比率做出解释</div>
                <Table
                    columns={columns}
                    dataSource={data.slice(6, 9)}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">酒店的盈利能力趋势分析</Row>
                {!loading && <TextArea
                    className="note m_b_80"
                    autosize={{ minRows: 8 }}
                    defaultValue={notes.profit}
                    onBlur={e => {
                        runInAction(() => {
                            this.props.store.monthlyAnalysis.notes.profit = e.target.value || "";
                        })
                    }}
                    placeholder={`示例：\n（1）客房利润率多少，主要是因为客房率多少，房价多少，所以影响客房利润率多少，未来改善计划。\n（2）餐饮部门利润率多少，主要是因为宴会收入达到多少金额，影响餐饮利润率多少，未来改善计划。\n（3）经营毛利率根据预算比率做出解释，未来改善计划。`}
                />}
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/profitability.js